import { render, staticRenderFns } from "./Stockchart_menu_mobile_top.vue?vue&type=template&id=95bf94ce&scoped=true&"
import script from "./Stockchart_menu_mobile_top.vue?vue&type=script&lang=js&"
export * from "./Stockchart_menu_mobile_top.vue?vue&type=script&lang=js&"
import style0 from "./Stockchart_menu_mobile_top.vue?vue&type=style&index=0&id=95bf94ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bf94ce",
  null
  
)

export default component.exports